import React from "react";
import styled from "styled-components";

const StyledTextarea = styled.textarea`
  &&& {
    background-color: #fff;
    margin-right: 3px;
    width: ${(props) => props.$width || "auto"};
    height: ${(props) => props.$height || "auto"};
  }
`;

const ContentTextarea = ({
  value,
  onChange,
  placeholder,
  maxLength,
  width = "96%",
  height = "34px",
  style = {},
  disabled = false,
}) => {
  return (
    <StyledTextarea
      $width={width}
      $height={height}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      maxLength={maxLength}
      style={{ ...style }}
      disabled={disabled}
    />
  );
};

export default ContentTextarea;
